import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2a1e01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "info block-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "申报详情", -1))
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "回款说明")
], -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "label-title" }
const _hoisted_8 = {
  key: 0,
  class: "pics"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "submit-btn"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "submit-btn"
}

import { flowsItem, projectItem, Approve } from '@/apis/base'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const type_name = ref('')
const collectionDetails = ref({
  explain: '', // 说明
  date: '', // 回款金额
  money: null, // 回款金额
  type: 1, // 1普通回款 2质保金
  tabsActive: 0, // 已发起
  approve_state: 0, // 审批流程
  pics: null, // 图片
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  approve: {} as Approve,
  project: {} as projectItem,
  flows: Array<flowsItem>()
})

const StaffInfo = ref({
  id: 0,
  name: '',
  avatar: ''
})
const showBottom = ref(false)
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  collectionDetails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  console.log(collectionDetails.value)

  type_name.value = router.currentRoute.value.query.type_name.toString()
  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_PreviewPicture = _resolveComponent("PreviewPicture")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_BottomButtonTwo = _resolveComponent("BottomButtonTwo")!
  const _component_BottomButtonOne = _resolveComponent("BottomButtonOne")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_DetailTitle, {
      approve: collectionDetails.value.approve
    }, null, 8, ["approve"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: collectionDetails.value.project.name,
              size: "large"
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "本次项目回款",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "回款类型",
              value: collectionDetails.value.type === 1 ? '普通回款' : '质保金'
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "回款金额（元）",
              value: collectionDetails.value.money
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "回款时间",
              value: collectionDetails.value.date
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, { type: "textarea" }, {
              title: _withCtx(() => [
                _hoisted_5
              ]),
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(collectionDetails.value.explain), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (collectionDetails.value.pics)
          ? (_openBlock(), _createBlock(_component_van_cell_group, {
              key: 0,
              title: "图片",
              border: false
            }, {
              default: _withCtx(() => [
                (collectionDetails.value.pics)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_PreviewPicture, {
                        imgs: collectionDetails.value.pics,
                        radius: 5,
                        width: 65,
                        height: 65
                      }, null, 8, ["imgs"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_van_cell_group, {
          title: "项目回款情况",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "合同金额（元）",
              value: collectionDetails.value.project?.contract?.money
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "质保金（元）",
              value: collectionDetails.value.project.contract?.shelf_life_money
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "已回款金额（元）",
              value: collectionDetails.value.money
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_ApprovalProcess, {
      flows: collectionDetails.value.flows
    }, null, 8, ["flows"]),
    (collectionDetails.value.tabsActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (collectionDetails.value.approve.approve_staff?.id === StaffInfo.value.id && collectionDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonTwo, {
                      key: 0,
                      typeId: collectionDetails.value.type_id,
                      itemId: collectionDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (collectionDetails.value.tabsActive == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (collectionDetails.value.approve.staff_id === StaffInfo.value.id && collectionDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonOne, {
                      key: 0,
                      typeId: collectionDetails.value.type_id,
                      itemId: collectionDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})